import React, { ComponentProps } from "react";

import "./StepIndicator.scss";

interface StepIndicatorProps extends ComponentProps<"div"> {
  currentStep: number;
  totalSteps?: number;
}

function StepIndicator({
  currentStep /* zero indexed */,
  totalSteps = 3,
  className = "",
  ...restProps
}: StepIndicatorProps) {
  return (
    <div className={`step-indicator ${className}`} {...restProps}>
      {Array.from({ length: totalSteps }).map((_, index) => {
        const isCurrentStep = currentStep === index;

        return (
          <span key={index} className="step" data-active={isCurrentStep} />
        );
      })}
    </div>
  );
}

export default StepIndicator;
